import axios from 'axios'
import React, { useContext, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import PlacementStudent from './PlacementStudent'
import Localbase from 'localbase'
import { useDispatch } from 'react-redux'
import { useActionsContext } from '../../context/ActionsContext'
import { AuthContext } from '../../context/AuthContext';

const PlacementStudents = () => {
    const dispatch = useDispatch()
    const db = new Localbase("db")

    const [placementData, setPlacementData] = useState([])
    const { rowsPerPage } = useActionsContext(); 
     const { user } = useContext(AuthContext);
    

    const fetchPLacementsData = async () => {
        try {
            dispatch({type:'LOADING'})
            const formData = new FormData();


  formData.append("session", user.SessionId);
  formData.append("limit" ,rowsPerPage);

            const res = await axios.post('https://siliconmindstechnologies.com/get-placed-students.php', formData)
            if (res) {
                setPlacementData(res.data.data)
                dispatch({ type: 'DONE_LOADING', data: res.data.data })
            }
            else {
                dispatch({
                    type: 'ERROR', payload: 'Failed to fetch data. Please try again later.'
                })
            }
        }
        catch (err) {
            dispatch({ type: 'ERROR', payload: err.message })
        }
    }
    useEffect(() => {
        fetchPLacementsData()
    }, [rowsPerPage])

    const RefreshplacementStudents = () => {
        fetchPLacementsData()
    }

    return (
        <div>
            <div>
                <div className="container-fluid d-flex justify-content-between">
                    <h2>Placed Students</h2>
                    <Link to="/add_student" className="btn btn-primary">
                        Add Student
                    </Link>
                </div>
                <hr></hr>
                <div className="container-fluid sm-p-15 d-flex flex-wrap">
                    {/* Map through the get-placed-students.php array */}
                    {placementData ?
                        <>

                            {placementData.map((student) => (
                                <PlacementStudent key={student.user_id} student={student} RefreshPla={RefreshplacementStudents} />
                            ))}
                        </> :
                        <>

                        </>}
                </div>
            </div>
        </div>
    )
}

export default PlacementStudents